import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SaveIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g>
            <path
               d="M2.572 3.42857V20.5714C2.572 21.0429 2.9578 21.4286 3.42934 21.4286H20.576C21.0476 21.4286 21.4334 21.0429 21.4334 20.5714V7.41964C21.4334 7.19464 21.3423 6.975 21.1815 6.81429L22.998 4.99821C23.641 5.64107 24 6.51429 24 7.425V20.5714C24 22.4625 22.4622 24 20.5707 24H3.42934C1.53784 24 0 22.4625 0 20.5714L0 3.42857C0 1.5375 1.53784 0 3.42934 0L16.5841 0C17.495 0 18.3684 0.358929 19.0114 1.00179L23.0033 4.99286L21.1869 6.80893L17.1896 2.82321C17.1735 2.80714 17.1628 2.79643 17.1467 2.78036V8.14286C17.1467 8.85536 16.5733 9.42857 15.8607 9.42857H5.57267C4.86001 9.42857 4.28667 8.85536 4.28667 8.14286V2.57143H3.42934C2.9578 2.57143 2.572 2.95714 2.572 3.42857ZM6.85867 2.57143V6.85714H14.5747V2.57143H6.85867ZM8.57334 15.4286C8.57334 14.5193 8.93465 13.6472 9.57777 13.0042C10.2209 12.3612 11.0932 12 12.0027 12C12.9122 12 13.7845 12.3612 14.4276 13.0042C15.0707 13.6472 15.432 14.5193 15.432 15.4286C15.432 16.3379 15.0707 17.21 14.4276 17.8529C13.7845 18.4959 12.9122 18.8571 12.0027 18.8571C11.0932 18.8571 10.2209 18.4959 9.57777 17.8529C8.93465 17.21 8.57334 16.3379 8.57334 15.4286Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10711_54534">
               <rect fill="currentColor" />
            </clipPath>
         </defs>
      </svg>
   )
}

export default SaveIcon
